"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var QuestionTextInput = function QuestionTextInput(_ref) {
  var question = _ref.question,
      _onChange = _ref.onChange;
  return _react.default.createElement(_UIFormControl.default, {
    label: _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.questionOrPrompt"
    }),
    className: "m-bottom-3"
  }, _react.default.createElement(_UITextInput.default, {
    autoFocus: true,
    value: question.question,
    onChange: function onChange(e) {
      return _onChange(question.setQuestionText(e.target.value));
    },
    "data-selenium-test": "question-and-answer-form-question-input",
    "data-onboarding-id": "question-text-input",
    placeholder: _I18n.default.text('composer-plugins.questionAndAnswer.questionPlaceholder')
  }));
};

QuestionTextInput.propTypes = {
  question: _propTypes.default.instanceOf(_QuestionEntityRecord.default).isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = QuestionTextInput;
exports.default = _default;
module.exports = exports.default;